export var logMap = {
    perf: {
        fp: "p1",
        fcp: "p2",
        lcp: "p3",
        startTime: "p4",
        unloadEventStart: "p5",
        unloadEventEnd: "p6",
        redirectStart: "p7",
        redirectEnd: "p8",
        fetchStart: "p9",
        domainLookupStart: "p10",
        domainLookupEnd: "p11",
        connectStart: "p12",
        secureConnectionStart: "p13",
        connectEnd: "p14",
        requestStart: "p15",
        responseStart: "p16",
        responseEnd: "p17",
        domInteractive: "p18",
        domContentLoadedEventStart: "p19",
        domContentLoadedEventEnd: "p20",
        domComplete: "p21",
        loadEventStart: "p22",
        loadEventEnd: "p23"
    },
    error: {
        // 转化
        file: "p1",
        lineno: "p2",
        colno: "p3",
        stack: "p4",
        errType: "p5",
        errCode: "p6",
        stack1: "p7",
        stack2: "p8",
        stack3: "p9"
    },
    api: {
        // 转化
        api: "p1",
        success: "p2",
        httpCode: "p3",
        code: "p4",
        time: "p5",
        traceId: "p6",
        params: "p7",
        response: "p8",
        header: "p9",
        requestType: "p10",
        method: "p11"
    },
    event: {
        id: "p1",
        eventType: "p2",
        xpath: "p3",
        success: "p4",
        time: "p5"
    },
    form: {
        formKey: "p1",
        feature: "p2",
        errors: "p3",
        status: "p4",
        fieldId: "p5",
        fieldLabel: "p6",
        url: "p7",
        submitCount: "p8",
        totalTime: "p9",
        pureTime: "p10",
        leaveTime: "p11",
        leaveCount: "p12",
        idleTime: "p13",
        idleCount: "p14",
        uuid: "p15",
        comps: "p16"
    },
    // 自定义测速
    speed: {
        t1: "p1",
        t2: "p2",
        t3: "p3",
        t4: "p4",
        t5: "p5",
        t6: "p6",
        t7: "p7",
        t8: "p8",
        t9: "p9",
        t10: "p10"
    },
    // 自定义统计(求和/求均值)
    calc: {
        method: "p1",
        key: "p2",
        value: "p3"
    },
    // 流程行为
    action: {
        action: "p3",
        actionType: "p4",
        result: "p5",
        actionCode: "p6",
        description: "p7",
        duration: "p8"
    },
    runtime: {
        // 用户停留时长
        stayTime: "p1",
        // 静态资源缓存命中率
        cacheUseRate: "p2",
        // 页面点击次数
        clickTimes: "p3",
        // 最大dom节点数
        maxNodesCount: "p4",
        // 响应延迟记录列表
        eventResponseDelayList: "p5",
        // 响应延迟发生次数
        eventResponseDelayTimes: "p6",
        // 卡顿记录列表
        longTaskList: "p7",
        // 卡顿发生次数
        longTaskTimes: "p8",
        // 表格记录 [ {xpath: 'table', columns: 10} ]
        tables: "p9",
        // 滚屏次数
        scrollPageTimes: "p10",
        // 体积大于500K的静态资源文件列表
        bigFiles: "p11",
        // 列多于10个的表格数量
        bigTableCount: "p12"
    }
};
export default logMap;
